import React from 'react'
import {Card, CardHeader, CardBody, CardFooter, CardTitle, } from "reactstrap";
import { Line } from "react-chartjs-2";
import { chartLine2 } from "../../variables/myCharts.js";
import { Chart as ChartJS, CategoryScale, ArcElement, LinearScale, PointElement, LineElement, Title, Tooltip,
  Legend, } from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    ArcElement,
    Title,
    Tooltip,
    Legend
  );


const _chart3 = () => {
  return (
    <Card className="card-chart">
    <CardHeader>
      <CardTitle tag="h5">NASDAQ: AAPL</CardTitle>
      <p className="card-category">Line Chart with Points</p>
    </CardHeader>
    <CardBody>
      {/* <Line
        data={dashboardNASDAQChart.data}
        options={dashboardNASDAQChart.options}
        width={400}
        height={100}
      /> */}
      <Line
        data={chartLine2}
        width={400}
        height={100}
      />
    </CardBody>
    <CardFooter>
      <div className="chart-legend">
        <i className="fa fa-circle text-info" /> Tesla Model S{" "}
        <i className="fa fa-circle text-warning" /> BMW 5 Series
      </div>
      <hr />
      <div className="card-stats">
        <i className="fa fa-check" /> Data information certified
      </div>
    </CardFooter>
  </Card>
  )
}

export default _chart3
